import { ApolloLink, HttpLink } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { ApolloClient, InMemoryCache } from '@apollo/client';

// Reference GATSBY_* directly so Gatsby's DefinePlugin inlines them in the client bundle.
// Do not wrap in typeof process checks or they may not be replaced.
const endpoint = process.env.GATSBY_CONTENTFUL_API_ENDPOINT ?? '';
const spaceId = process.env.GATSBY_CONTENTFUL_SPACE_ID ?? '';
const environment = process.env.GATSBY_CONTENTFUL_ENVIRONMENT ?? '';
const token = process.env.GATSBY_CONTENTFUL_DELIVERY_API_ACCESS_TOKEN ?? '';

const contentfulUrl =
  endpoint && spaceId && environment
    ? `${endpoint}${spaceId}/environments/${environment}`
    : '';

const httpLink = new HttpLink({
  uri: contentfulUrl,
  headers:
    token && contentfulUrl
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {},
});

const retryLink = new RetryLink();

/** Link for Contentful GraphQL; used by the main client’s split (when context.clientName === contentfulClientName). */
export const contentfulLink = ApolloLink.from([retryLink, httpLink]);

export const hasContentfulConfig = Boolean(contentfulUrl && token);

export const contentfulClientName = 'contentful';

/** Standalone client for getCMS (SSR / server) where the provider client isn’t used. */
export const contentfulClient = new ApolloClient({
  link: contentfulLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: { fetchPolicy: 'no-cache' },
    watchQuery: { fetchPolicy: 'no-cache' },
  },
});
